import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useQuery } from '@tanstack/react-query';
import { TmaisBannerData } from '../types/tmaisBanner.type';
import { TmaisBannersTransformer } from '../services/tmaisBannersTransformer';

type UseTmaisBannerProps = {
  id?: string;
  mapper?: (data: any) => TmaisBannerData;
};

export const useTmaisBanner = ({ 
  id, 
  mapper = TmaisBannersTransformer.showTransformer() 
}: UseTmaisBannerProps) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    queryKey: ['tmaisBanner', id],
    queryFn: async () => {
      const response = await privateAxios.get(`/tmais/banners/${id}`);
      const showData = response.data?.data || response.data;
      
      return mapper(showData);
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5, 
  });
};